const mod = require('i18next-browser-languagedetector')

module.exports = mod
